import React, { createContext, useContext, useEffect, useState } from "react";
import { translations, t as translate, RTL_LANGUAGES } from "@/i18n/translations";

const LanguageContext = createContext(null);

const applyLangSideEffects = (l) => {
  if (typeof document === "undefined") return;
  document.documentElement.lang = l;
  document.documentElement.dir = RTL_LANGUAGES.includes(l) ? "rtl" : "ltr";
  document.documentElement.classList.toggle("font-tamil", l === "ta");
  document.documentElement.classList.toggle("font-ethiopic", l === "ti");
  document.documentElement.classList.toggle("font-arabic", l === "ar");
};

export const LanguageProvider = ({ children }) => {
  const [lang, setLangState] = useState(() => {
    const saved = typeof window !== "undefined" ? localStorage.getItem("rs_lang") : null;
    return saved && translations[saved] ? saved : "de";
  });

  const setLang = (l) => {
    if (translations[l]) {
      setLangState(l);
      localStorage.setItem("rs_lang", l);
      applyLangSideEffects(l);
    }
  };

  useEffect(() => {
    applyLangSideEffects(lang);
  }, [lang]);

  const t = (key) => translate(lang, key);
  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLanguage must be used within LanguageProvider");
  return ctx;
};
